var databaseURL = () => {
  if (window.location.hostname === "192.168.86.53") {
    return "http://192.168.86.53:9000?ns=premises-2af49";
  }

  return "https://premises-2af49.firebaseio.com/";
}

const firebaseConfig = { 
  apiKey: "AIzaSyBZj-bKk33vwqWJptKqITNnogu8_vLdKIs", 
  authDomain: "app.getpremises.com", 
  databaseURL: databaseURL(), 
  projectId: "premises-2af49",
  storageBucket: "premises-2af49.appspot.com/", 
  messagingSenderId: "1039269062579"
};

export { firebaseConfig }



// WEBPACK FOOTER //
// ./src/components/webmaster/config/firebase.js